// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A6BpyvAhaD00VO0a72GG {
	display: flex;
	align-items: center;
	list-style: none;
	padding: 4px;
	margin: 0;
	border-radius: 12px;
	background-color: var(--gray);
}

.hITdOyKcDnXU5GT8JAEy {
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
	height: 40px;
	border-radius: 10px;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
}

.hITdOyKcDnXU5GT8JAEy:hover {
		cursor: pointer;
	}

.hITdOyKcDnXU5GT8JAEy.oSpTc6VLNGuu4q5E5B2b {
		background-color: var(--white);
		pointer-events: none;
	}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Tabs.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,SAAS;CACT,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,OAAO;CACP,YAAY;CACZ,mBAAmB;CACnB,yBAAiB;IAAjB,sBAAiB;SAAjB,iBAAiB;AAUlB;;AARC;EACC,eAAe;CAChB;;AAEA;EACC,8BAA8B;EAC9B,oBAAoB;CACrB","sourcesContent":[".tabs {\n\tdisplay: flex;\n\talign-items: center;\n\tlist-style: none;\n\tpadding: 4px;\n\tmargin: 0;\n\tborder-radius: 12px;\n\tbackground-color: var(--gray);\n}\n\n.item {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex: 1;\n\theight: 40px;\n\tborder-radius: 10px;\n\tuser-select: none;\n\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n\n\t&.active {\n\t\tbackground-color: var(--white);\n\t\tpointer-events: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `A6BpyvAhaD00VO0a72GG`,
	"item": `hITdOyKcDnXU5GT8JAEy`,
	"active": `oSpTc6VLNGuu4q5E5B2b`
};
export default ___CSS_LOADER_EXPORT___;
